// bidView rides along because the bid page fires onFeedNavigate on load to pick a default tab, and a
// dropped param means the ?bidView= override never reaches BidDetails at all.
const PRESERVED_INBOX_QUERY_KEYS = [
  "viewId",
  "teamId",
  "inboxFilters",
  "inboxSort",
  "inboxDir",
  "dailyAction",
  "bidView",
] as const;

export const preservedInboxSearch = (query: Record<string, string | string[] | undefined>): string => {
  const params = new URLSearchParams();
  for (const key of PRESERVED_INBOX_QUERY_KEYS) {
    const value = query[key];
    if (typeof value === "string") {
      params.set(key, value);
    }
  }
  return params.toString();
};
